import { ActivityIcon, CalendarRangeIcon, MapIcon, UserRoundIcon } from 'lucide-react-native';
import type { LucideIcon } from 'lucide-react-native';

export type TabRouteName = 'events' | 'map' | 'activity' | 'profile';

export type NavItem = {
  icon: LucideIcon;
  label: string;
};

export const TAB_CONFIG: Record<TabRouteName, NavItem> = {
  events: { icon: CalendarRangeIcon, label: 'Events' },
  map: { icon: MapIcon, label: 'Map' },
  activity: { icon: ActivityIcon, label: 'Pulse' },
  profile: { icon: UserRoundIcon, label: 'Profile' },
};
